"use client";

import { c as _c } from "react/compiler-runtime";
import { cn } from "@/lib/utils";
import { Incrementor } from "./Incrementor";
type FormIncrementorProps = React.ComponentProps<typeof Incrementor> & {
  /** Reflects validation state — paints the pill with destructive ring/border. */
  "aria-invalid"?: boolean;
  /** Apply opacity-50 + not-allowed cursor. Passed straight to the stepper too. */
  disabled?: boolean;
  /** Override class on the pill wrapper. */
  containerClassName?: string;
};

/**
 * Form-styled incrementor. Thin wrapper that places the bare `Incrementor`
 * inside the same pill-shaped bordered container used by `Input` and
 * `FormDatePicker`, so the stepper looks like a sibling of the other form
 * fields. Use inside `FormField` / `FormItem` / `FormControl`. For non-form
 * contexts (filters, drawers) use the bare `Incrementor` directly.
 */
export function FormIncrementor(t0) {
  const $ = _c(27);
  let T0;
  let t1;
  let t2;
  let t3;
  let t4;
  let t5;
  let t6;
  let t7;
  let t8;
  if ($[0] !== t0) {
    const {
      "aria-invalid": ariaInvalid,
      disabled,
      containerClassName,
      className,
      ...props
    } = t0;
    t4 = "form-incrementor";
    t5 = ariaInvalid;
    const t9 = disabled && "opacity-50 cursor-not-allowed";
    if ($[10] !== containerClassName || $[11] !== t9) {
      t6 = cn("flex h-11 items-center w-full max-w-56 rounded-full border border-input bg-input-bg px-1 shadow-xs transition-[color,box-shadow] aria-invalid:ring-destructive/20 aria-invalid:border-destructive", t9, containerClassName);
      $[10] = containerClassName;
      $[11] = t9;
      $[12] = t6;
    } else {
      t6 = $[12];
    }
    t7 = "FormIncrementor";
    t8 = "FormIncrementor.tsx";
    T0 = Incrementor;
    t1 = props;
    if ($[13] !== className) {
      t2 = cn("w-full !max-w-none gap-0", className);
      $[13] = className;
      $[14] = t2;
    } else {
      t2 = $[14];
    }
    t3 = cn("!max-w-none", props.controlsClassName);
    $[0] = t0;
    $[1] = T0;
    $[2] = t1;
    $[3] = t2;
    $[4] = t3;
    $[5] = t4;
    $[6] = t5;
    $[7] = t6;
    $[8] = t7;
    $[9] = t8;
  } else {
    T0 = $[1];
    t1 = $[2];
    t2 = $[3];
    t3 = $[4];
    t4 = $[5];
    t5 = $[6];
    t6 = $[7];
    t7 = $[8];
    t8 = $[9];
  }
  let t9;
  if ($[15] !== T0 || $[16] !== t1 || $[17] !== t2 || $[18] !== t3) {
    t9 = <T0 {...t1} className={t2} controlsClassName={t3} data-sentry-element="Incrementor" data-sentry-source-file="FormIncrementor.tsx" />;
    $[15] = T0;
    $[16] = t1;
    $[17] = t2;
    $[18] = t3;
    $[19] = t9;
  } else {
    t9 = $[19];
  }
  let t10;
  if ($[20] !== t4 || $[21] !== t5 || $[22] !== t6 || $[23] !== t7 || $[24] !== t8 || $[25] !== t9) {
    t10 = <div data-slot={t4} aria-invalid={t5} className={t6} data-sentry-component={t7} data-sentry-source-file={t8}>{t9}</div>;
    $[20] = t4;
    $[21] = t5;
    $[22] = t6;
    $[23] = t7;
    $[24] = t8;
    $[25] = t9;
    $[26] = t10;
  } else {
    t10 = $[26];
  }
  return t10;
}